<template>
    <a class="T_ComEventAppIns com-install-btn" href="javascript:void(0)" onclick="qqapp_dl_apk(this);" :ex_url="`${ex_url}`" :asistanturlid="`${comAsistanturlid}`" :appname="`${appname}`" :apk="`${apk}`" :appicon="`${appicon}`">安装到手机</a>
</template>

<script>
export default {
  name: 'com-ins-btn',
  props: ['ex_url', 'asistanturlid', 'appname', 'apk', 'appicon'],
  data () {
    return {
      comAsistanturlid: '990499'
    };
  }
};
</script>
